"use client";

import {
  type DependencyList,
  type EffectCallback,
  useEffect,
  useRef,
} from "react";

/**
 * A hook that runs an effect only after the component has been initialized.
 * @param effect - The effect to run.
 * @param deps - The dependencies of the effect.
 */
export const useInitializedEffect = (
  effect: EffectCallback,
  deps: DependencyList,
) => {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) {
      effect();
      return;
    }

    initialized.current = true;
  }, deps);
};
